"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.SUB_ICON = exports.DISPLAYS = exports.COLORS = exports.CARRIER_TEXT = exports.CABIN_CLASS = void 0;
var TRANSLATION = {
  hour: 'h',
  minute: 'm',
  day: 'day',
  economy: 'Economy',
  premium_economy: 'Economy Premium',
  business: 'Business',
  first: 'First Class',
  operated: 'Operated By:'
};
exports.TRANSLATION = TRANSLATION;
var CABIN_CLASS = {
  M: 'economy',
  W: 'premium_economy',
  C: 'business',
  F: 'first'
};
exports.CABIN_CLASS = CABIN_CLASS;
var COLORS = {
  greyDark: 'greyDark'
};
exports.COLORS = COLORS;
var DISPLAYS = {
  block: 'block',
  inlineFlex: 'inlineFlex'
};
exports.DISPLAYS = DISPLAYS;
var SUB_ICON = 'SubdirectoryArrowRight';
exports.SUB_ICON = SUB_ICON;
var CARRIER_TEXT = {
  SUB: 'sub',
  FONT_SIZE: 'normal',
  PADDING: 'semiXLarge'
};
exports.CARRIER_TEXT = CARRIER_TEXT;